// Front/src/context/AuthContext.js

import { createContext, useReducer, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types';

export const AuthContext = createContext()

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload, loading: false }
        case 'LOGOUT':
            return { user: null, loading: false }
        case 'AUTH_READY':
            return { user: action.payload, loading: false }
        default:
            return state
    }
}


export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
        loading: true
    })

    const value = useMemo(() => ({ ...state, dispatch }), [state, dispatch]);

    useEffect(() => {
        
        const user = JSON.parse(localStorage.getItem('user'))

        // Instead of calling LOGIN or LOGOUT here, just dispatch AUTH_READY
        dispatch({ type: 'AUTH_READY', payload: user || null })
    }, [])

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
    
}

AuthContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};